import React, { useEffect, useState } from 'react'
import { Alert, Typography, withStyles } from '@material-ui/core'
import styles from '../styles'

const SuccessAlert = ({ classes, show, onHide }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onHide()
      }, 3000)

      return () => clearTimeout(timer)
    }
  }, [show, onHide])

  if (!show) return null

  return (
    <Alert severity="success" className={classes.successAlert}>
      <Typography>Settings saved successfully</Typography>
    </Alert>
  )
}

export default withStyles(styles)(SuccessAlert)
